module.exports = require('./helpers/bundle-url').getBundleURL('AYXBA') + "empty-state.34f16b81.svg";